import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {
  Question_Types,
  Markets,
  Categories,
  Question_Bonuses,
} from '@core/generated-gql/graphql';
import { Category } from '@core/models';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FormControlUtilitiesService {
  private unsubscribe$: Subject<void> = new Subject();
  constructor() {}

  /**
   * @deprecated Use findIndex instead
   */
  public decideFormValues(
    formItemList:
      | Question_Types[]
      | Markets[]
      | Category[]
      | Categories[]
      | Question_Bonuses[],
    formItemKey: string,
    value: string | number
  ): number {
    for (let i = 0; i < formItemList.length; i++) {
      if (value === formItemList[i][formItemKey]) {        
        return i;
      }
    }
  }

  /**
   * marks controls by given controlName in a formGroup as touched
   * @param form FormGroup
   * @param controlName string
   */
  public controlValueChanges(form: UntypedFormGroup, controlName: string): void {
    form
      .get(controlName)
      .valueChanges.pipe(takeUntil(this.unsubscribe$), distinctUntilChanged())
      .subscribe((data) => {
        if (form.get(controlName).invalid) {
          form.get(controlName).markAllAsTouched();
        }
      });
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
